module.exports = __webpack_public_path__ + "static/glasses-process-9e8062b394254485e1b159042151c646.jpg";